import { PERMISSIONS, PermissionType } from '../permissions/permissions';

export type Role = {
  name: RoleName;
  description: string;
  permissions: PermissionType[];
  color: string;
  managedBy?: string[];
};

export enum RoleName {
  SUPER_ADMIN = 'Super Admin',
  MEMBER_MANAGER = 'Member Manager',
  RETRO_ADMIN = 'RetroScore Admin',
  RETRO_USER = 'RetroScore User',
  RETRO_ANALOGS = 'RetroScore Analogs',
  RETRO_DEBUG = 'RetroScore Debug',
  MARIA_ADMIN = 'Maria Admin',
  MARIA_USER = 'Maria User',
}

export const ROLES: Role[] = [
  {
    name: RoleName.SUPER_ADMIN,
    description: 'Enables organization and all roles management',
    permissions: [PERMISSIONS.HUB.MANAGE_ORGANIZATIONS, PERMISSIONS.HUB.MANAGE_USERS],
    color: 'plum',
    managedBy: [PERMISSIONS.HUB.MANAGE_ORGANIZATIONS],
  },
  {
    name: RoleName.MEMBER_MANAGER,
    description: 'Enables access management and creation of members within the organization',
    permissions: [PERMISSIONS.HUB.MANAGE_USERS],
    color: 'grass',
  },
  {
    name: RoleName.RETRO_ADMIN,
    description: 'Grants admin access to M1 RetroScore',
    permissions: [
      PERMISSIONS.RETRO.APP.ADMIN,
      PERMISSIONS.RETRO.APP.READ,
      PERMISSIONS.RETRO.APP.WRITE,
      PERMISSIONS.RETRO.APP.DELETE,
      PERMISSIONS.RETRO.API.ADMIN,
      PERMISSIONS.RETRO.API.READ,
      PERMISSIONS.RETRO.API.WRITE,
      PERMISSIONS.RETRO.API.DELETE,
    ],
    color: 'blue',
    managedBy: [PERMISSIONS.HUB.MANAGE_ORGANIZATIONS],
  },
  {
    name: RoleName.RETRO_USER,
    description: 'Grants access to the base functionality in M1 RetroScore',
    permissions: [
      PERMISSIONS.RETRO.APP.READ,
      PERMISSIONS.RETRO.APP.WRITE,
      PERMISSIONS.RETRO.APP.DELETE,
      PERMISSIONS.RETRO.API.READ,
      PERMISSIONS.RETRO.API.WRITE,
      PERMISSIONS.RETRO.API.DELETE,
    ],
    color: 'blue',
  },
  {
    name: RoleName.RETRO_ANALOGS,
    description: 'Enables analogs in M1 RetroScore',
    permissions: [PERMISSIONS.RETRO.APP.ANALOGS],
    color: 'blue',
    managedBy: [PERMISSIONS.HUB.MANAGE_ORGANIZATIONS],
  },
  {
    name: RoleName.RETRO_DEBUG,
    description: 'Enables debug tools in M1 RetroScore',
    permissions: [PERMISSIONS.RETRO.DEBUG],
    color: 'blue',
    managedBy: [PERMISSIONS.HUB.MANAGE_ORGANIZATIONS],
  },
  {
    name: RoleName.MARIA_ADMIN,
    description: 'Grants admin access to M1 Maria',
    permissions: [...Object.values(PERMISSIONS.MARIA)],
    color: 'pink',
    managedBy: [PERMISSIONS.HUB.MANAGE_ORGANIZATIONS],
  },
  {
    name: RoleName.MARIA_USER,
    description: 'Grants access to M1 Maria',
    permissions: [PERMISSIONS.MARIA.READ, PERMISSIONS.MARIA.WRITE],
    color: 'pink',
    managedBy: [PERMISSIONS.HUB.MANAGE_ORGANIZATIONS],
  },
];
